export const useStyles = () => {
    return {
        styles: {
            container: {
                display: "flex",
                flexWrap: "wrap",
                rowGap: "24px",
                marginTop: "16px"
            },
            autocomplete: {
                 width: "100%",
               "& .MuiTextField-root":  {
                 width: "100%"
               }
            },
            modal: {
                width: "400px"
            },
            footer: {
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                columnGap: "10px"
            }
        }
    }
}